// Accordion Menu Enhancement for Header Drawer
class AccordionMenuDrawer extends HTMLElement {
  constructor() {
    super();
    
    this.mainDetailsToggle = this.querySelector('details');
    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.init();
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    if (openDetailsElement === this.mainDetailsToggle) {
      this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'));
    }
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 1101px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      // Handle accordion behavior for submenus
      const isCurrentlyOpen = detailsElement.hasAttribute('open');
      
      // Close other accordions at the same level
      const siblings = detailsElement.parentElement.querySelectorAll(':scope > li > .menu-drawer__accordion');
      siblings.forEach(sibling => {
        if (sibling !== detailsElement && sibling.hasAttribute('open')) {
          sibling.removeAttribute('open');
        }
      });
    }
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);

    if (this.header) {
      this.header.classList.remove('menu-open');
    }
    window.removeEventListener('resize', this.onResize);

    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };

  init() {
    // Add click handlers for main menu items that should close drawer
    this.querySelectorAll('a:not(.menu-drawer__accordion-trigger)').forEach(link => {
      link.addEventListener('click', () => {
        // Close the main drawer when a link is clicked
        if (this.mainDetailsToggle && this.mainDetailsToggle.hasAttribute('open')) {
          setTimeout(() => {
            this.mainDetailsToggle.removeAttribute('open');
            this.closeMenuDrawer(new Event('click'), this.mainDetailsToggle.querySelector('summary'));
          }, 150);
        }
      });
    });
     // Initialize mobile country selector
    // this.initMobileCountryToggle();
  }

  initMobileCountryToggle() {
    // Use a small delay to ensure DOM is ready
    setTimeout(() => {
      const selector = this.querySelector('.country-selector--mobile');
      const countryCurrent = this.querySelector('.country-current--mobile');
      const countryLinks = this.querySelectorAll('.country-option--mobile');
      
      if (!selector || !countryCurrent) {
        console.log('Mobile country selector elements not found');
        return;
      }

      // Toggle dropdown on flag click
      countryCurrent.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        selector.classList.toggle('open');
      });

      // Close dropdown when clicking outside
      document.addEventListener('click', (e) => {
        if (!selector.contains(e.target)) {
          selector.classList.remove('open');
        }
      });

      // Handle country link clicks
      countryLinks.forEach(link => {
        link.addEventListener('click', (e) => {
          const href = link.getAttribute('href');
          if (href) {
            const currentPath = window.location.pathname + window.location.search + window.location.hash;
            window.location.href = href + currentPath;
          }
        });
      });
    }, 100);

  }
}



// Only initialize if it's not already a custom element
if (!customElements.get('accordion-menu-drawer')) {
  customElements.define('accordion-menu-drawer', AccordionMenuDrawer);
}
